function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVectorLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.54,
    d: "M8.59537 6.0397L13.7912 0H12.5599L8.04842 5.24419L4.44508 0H0.289062L5.73801 7.93014L0.289062 14.2637H1.52037L6.28465 8.72566L10.09 14.2637H14.2461L8.59507 6.0397H8.59537ZM6.90892 8.00001L6.35683 7.21035L1.96403 0.926912H3.85525L7.40029 5.99784L7.95238 6.78751L12.5605 13.3789H10.6693L6.90892 8.00031V8.00001Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorLight);
export default __webpack_public_path__ + "static/media/Vector_light.306d80767be9ce532ed7a3d5a7ec0526.svg";
export { ForwardRef as ReactComponent };